var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApollo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.14 84.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "APOLLO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.68,23.9h-8.8l-12.71,33h8l2.2-6H47.13L45,44.9H36.94l5.25-14.48L51.53,56.9H59.4Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.33,66.11a1.77,1.77,0,0,0-1.46.75s-1.56,1.78-2.38,2.63a38.54,38.54,0,0,1-12.26,8.28,38.09,38.09,0,0,1-15,3,38.75,38.75,0,0,1-15-3,38.15,38.15,0,0,1-12.27-8.28A38.87,38.87,0,0,1,6.61,57.23a38.26,38.26,0,0,1-3-15,38.75,38.75,0,0,1,3-15,37.58,37.58,0,0,1,8.25-12.27A38.87,38.87,0,0,1,27.12,6.61a38.23,38.23,0,0,1,15-3,38.75,38.75,0,0,1,15,3,38.33,38.33,0,0,1,9.24,5.55,4.59,4.59,0,0,0-.25,1.42,4.38,4.38,0,1,0,4.38-4.37,3.65,3.65,0,0,0-1.67.35,42.18,42.18,0,1,0,5.72,59.61,1.8,1.8,0,0,0,.53-1.24,1.86,1.86,0,0,0-1.81-1.82Z",
    style: {
      fill: "#19405e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApollo);
export default __webpack_public_path__ + "static/media/APOLLO.411b339459aec3128de6367cc8047122.svg";
export { ForwardRef as ReactComponent };